import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Assessment from "./pages/Assessment";
import WorkstreamDetail from "./pages/WorkstreamDetail";
import TaskBoard from "./pages/TaskBoard";
import ProjectPlan from "./pages/ProjectPlan";
import PMO from "./pages/PMO";
import MyResponsibility from "./pages/MyResponsibility";
import Reports from "./pages/Reports";
import Inventory from "./pages/Inventory";
import Notifications from "./pages/Notifications";
import Compliance from "./pages/Compliance";
import AdminUsers from "./pages/AdminUsers";
import AdminConfig from "./pages/AdminConfig";
import AdminAudit from "./pages/AdminAudit";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center text-[#5A687C]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Home /></Protected>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/assessment" element={<Protected><Assessment /></Protected>} />
            <Route path="/workstream/:id" element={<Protected><WorkstreamDetail /></Protected>} />
            <Route path="/workstream/:id/tasks" element={<Protected><TaskBoard /></Protected>} />
            <Route path="/project-plan" element={<Protected><ProjectPlan /></Protected>} />
            <Route path="/pmo" element={<Protected><PMO /></Protected>} />
            <Route path="/my-responsibility" element={<Protected><MyResponsibility /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/inventory" element={<Protected><Inventory /></Protected>} />
            <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
            <Route path="/compliance" element={<Protected><Compliance /></Protected>} />
            <Route path="/admin/users" element={<Protected><AdminUsers /></Protected>} />
            <Route path="/admin/config" element={<Protected><AdminConfig /></Protected>} />
            <Route path="/admin/audit-log" element={<Protected><AdminAudit /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
